export default "__VITE_ASSET__BLLaMWfi__"